import { axiosLevelTech } from '../axiosConfig';
import { showToast } from '@/services/notifications/toastService';

// TypeScript interfaces for popup operations
export interface popup {
  id: number;
  name: string;
  cookie_timeout: number;
  enabled: boolean;
  start_datetime: string;
  end_datetime: string;
  content: {
    content: string;
    btn_1_href: string;
    btn_1_content: string;
    img_url: string;
  };
  detail: {
    any: Criteria;
    only: Criteria[];
  };
  status: string;
}

export interface Criteria {
  admin: string | string[];
  federation: string | string[];
  community: string | string[];
  region: string | string[];
  country: string | string[];
  membership: string | string[];
  location: string | string[];
}

// Function to get popups collection
export const getAllPopUps = async (ids?: number[]) => {
  const requestBody = ids ? { ids } : {}; // Directly set the ids array without a payload wrapper
  return axiosLevelTech
    .post('api/popup/GetAllPopUps', requestBody)
    .then((response) => handleResponse(response, 'All popups fetched successfully!'))
    .catch(handleError);
};

// Function to create a new popup
export const createpopup = async (popup: Record<string, any>) => {
  const requestBody = popup;
  return axiosLevelTech
    .post('api/popup/CreatePopUp', requestBody)
    .then((response) => handleResponse(response, 'Popup created successfully!'))
    .catch(handleError);
};

// Function to edit a popup
export const editpopup = async (popup: Record<string, any>) => {
  const requestBody = popup;
  return axiosLevelTech
    .post('api/popup/UpdatePopUp', requestBody)
    .then((response) => handleResponse(response, 'Popup edited successfully!'))
    .catch(handleError);
};

// Function to remove popups
export const removePopUp = async (id: number) => {
  const requestBody = { id };
  return axiosLevelTech
    .post('api/popup/RemovePopUp', requestBody)
    .then((response) => handleResponse(response, 'Popup removed successfully!'))
    .catch(handleError);
};


export const getPopUpsForUser = async () => {
  return axiosLevelTech
    .post('api/popup/GetPopUpsForUser')
    .then((response) => handleResponse(response, 'User popups fetched successfully!', true))
    .catch(handleError);
};

export const addTriggerForPopUp = async (popupId: number, personId: number) => {
  const requestBody = {
    personId: personId,
    trigger: JSON.stringify({ type: "pop_up", popupid: popupId })
  };
  return axiosLevelTech
    .post('api/trigger/AddTrigger', requestBody)
    .then((response) => handleResponse(response, 'Trigger that triggers popup for this user added successfully!'))
    .catch(handleError);
}

function handleResponse(response: any, successMessage: string, suppressToast = false) {
  if (response.data.status === 'Success') {
    if (!suppressToast) showToast('success', response.data.message || successMessage);
  } else {
    showToast('error', response.data.message || 'Failed to perform operation.');
    throw new Error(response.data.message || 'An unknown error occurred.');
  }
  return response.data;
}

// Helper function to handle errors
function handleError(error: any) {
  showToast('error', error.response?.data?.message || `${error.message}`);
  throw new Error(error.message || 'An unknown error occurred.');
}